// client/src/Backend.jsx
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import './Backend.css';
import * as XLSX from "xlsx";
import Select from "react-select"; 

export default function BackendDataPage() {
  const { tenantSlug } = useParams();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const [selectedTableId, setSelectedTableId] = useState(null);
  const [selectedTableTxns, setSelectedTableTxns] = useState([]);
  const [showTableTxns, setShowTableTxns] = useState(false);


  // ── State ───────────────────────────────────────────────
  const [start, setStart] = useState("");      // "YYYY-MM-DD"
  const [end, setEnd] = useState("");          // "YYYY-MM-DD"
  const [sortBy, setSortBy] = useState("");    // Whitelisted sort field
  const [tablesData, setTablesData] = useState([]);
  const [error, setError] = useState("");
  const [showTables, setShowTables] = useState(false);
  const [sortOrder, setSortOrder] = useState("desc");

  //Adding users
  const [staffEmail, setStaffEmail] = useState("");
  const [staffPassword, setStaffPassword] = useState("");
  const [staffError, setStaffError] = useState("");
  const [staffSuccess, setStaffSuccess] = useState("");
  const [staffPasswordRepeat, setStaffPasswordRepeat] = useState("");
  const [staffRole, setStaffRole] = useState("");
  const role  = localStorage.getItem("role");

  const [players, setPlayers] = useState([]);               // All players list
  const [selectedPlayer, setSelectedPlayer] = useState(null); // { value: id, label: name }
  const [playerStart, setPlayerStart] = useState("");       // “YYYY-MM-DD”
  const [playerEnd, setPlayerEnd] = useState("");           // “YYYY-MM-DD”
  const [playerTxns, setPlayerTxns] = useState([]);         // Fetched transactions
  const [showPlayerTxns, setShowPlayerTxns] = useState(false);
  const [playerError, setPlayerError] = useState("");


// ── New “All Players” state ───────────────────────────────
  const [playersData, setPlayersData] = useState([]);        // Array of all‐players objects
  const [playerSortBy, setPlayerSortBy] = useState("created_at"); // Default sort
  const [showPlayersData, setShowPlayersData] = useState(false);
  const [playersError, setPlayersError] = useState("");
  const [sortPlayerOrder, setSortPlayerOrder] = useState("desc");


//DEALERS SELECT
  const [dealers, setDealers] = useState([]);               // All players list
  const [selectedDealer, setSelectedDealer] = useState(null); // { value: id, label: name }
  const [dealerStart, setDealerStart] = useState("");       // “YYYY-MM-DD”
  const [dealerEnd, setDealerEnd] = useState("");           // “YYYY-MM-DD”
  const [dealerTxns, setDealerTxns] = useState([]);         // Fetched transactions
  const [showDealerTxns, setShowDealerTxns] = useState(false);
  const [dealerError, setDealerError] = useState("");



  // ── New “All Dealers” state ───────────────────────────────
 const [dealersData, setDealersData] = useState([]);          // array of all‐dealers objects
 const [dealerSortBy, setDealerSortBy] = useState("tips");    // default sort key
 const [showDealersData, setShowDealersData] = useState(false);
 const [dealersError, setDealersError] = useState("");

  //TRANSACTIONS
  const [backendStart, setBackendStart] = useState("");
  const [backendEnd, setBackendEnd] = useState("");
  const [includePlayers, setIncludePlayers] = useState(false);
  const [includeDealers, setIncludeDealers] = useState(false);
  const [includeBonuses, setIncludeBonuses] = useState(false);
  const [includeCosts, setIncludeCosts] = useState(false);
  const [includeRake, setIncludeRake] = useState(false);
  const [includeDebt, setIncludeDebt] = useState(false);
  const [backendData, setBackendData] = useState([]);
  const [showBackendData, setShowBackendData] = useState(false);
  const [backendError, setBackendError] = useState("");

 
 const [stats, setStats] = useState({
    total_table_rake:   null,  // will become a number
    total_costs:        null,  // will become a number
    net_profit:         null,  // total_table_profit − total_costs
  });
  const [statsLoading, setStatsLoading] = useState(true);
  const [statsError, setStatsError]     = useState("");






  // ── Attach the JWT header & redirect if missing ─────────
  useEffect(() => {
    if (!token) {
      navigate(`/${tenantSlug}/login`);
      return;
    }
    if (role !== "admin") {
      navigate(`/${tenantSlug}/login`);
      return;
    }
    axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    const loadPlayers = async () => {
      try {
        const { data } = await axios.get(`/${tenantSlug}/api/players`);
        // Transform into react-select format: { value: id, label: name }
        const options = data.map((p) => ({
          value: p.id,
          label: p.name,
        }));
        setPlayers(options);
      } catch (err) {
        console.error("Failed to load players:", err);
      }
    };
    const loadDealers = async () => {
      try {
        const { data } = await axios.get(`/${tenantSlug}/api/dealers`);
        // Transform into react-select format: { value: id, label: name }
        const options = data.map((d) => ({
          value: d.id,
          label: d.name,
        }));
        setDealers(options);
      } catch (err) {
        console.error("Failed to load dealer:", err);
      }
    };
    loadPlayers();
    loadDealers();
  }, [token, tenantSlug, navigate, role]);



  useEffect(() => {
    const fetchStats = async () => {
      setStatsLoading(true);
      setStatsError("");
      try {
        const { data } = await axios.get(`/${tenantSlug}/api/stats`);
        setStats({
          total_table_rake: data.total_table_rake,
          total_costs:        data.total_costs,
          total_bonuses:      data.total_bonuses,
          net_profit:         data.net_profit,
        });
      } catch (err) {
        console.error("Failed to load stats:", err);
        setStatsError(err.response?.data?.error || "Failed to load stats");
      } finally {
        setStatsLoading(false);
      }
    };

    fetchStats();
  }, [tenantSlug]);

  // ── Build the “sort_by” query string (or blank) ──────────
  const buildSortParam = () => {
    const colPart = sortBy ? `&sort_by=${encodeURIComponent(sortBy)}` : "";
    const orderPart = sortBy ? `&order=${encodeURIComponent(sortOrder)}` : ""; // **NEW**
    return colPart + orderPart;
  };


  const fetchTransactionsForTable = async (tableId) => {
    try {
      const res = await axios.get(
        `/${tenantSlug}/api/tables/${tableId}/transactions`
      );
      setSelectedTableId(tableId);
      setSelectedTableTxns(res.data);
      setShowTableTxns(true);
      setError("");
    } catch (err) {
      console.error("Error fetching table transactions:", err);
      setError("Failed to load transactions for table " + tableId);
    }
  };

  // ── Cancel/hide transactions ─────────────────────
  const hideTableTransactions = () => {
    setShowTableTxns(false);
    setSelectedTableId(null);
    setSelectedTableTxns([]);
  };




  const exportPlayerToExcel = () => {
    if (!playerTxns || playerTxns.length === 0) {
      alert("No player transactions to export.");
      return;
    }
    // Convert playerTxns (array of objects) into a worksheet
    const worksheet = XLSX.utils.json_to_sheet(playerTxns);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "PlayerTxns");
    XLSX.writeFile(workbook, `${tenantSlug}_player_transactions.xlsx`);
  };

  const exportDealerToExcel = () => {
    if (!dealerTxns || dealerTxns.length === 0) {
      alert("No dealer transactions to export.");
      return;
    }
    // Convert playerTxns (array of objects) into a worksheet
    const worksheet = XLSX.utils.json_to_sheet(dealerTxns);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "DealerTxns");
    XLSX.writeFile(workbook, `${tenantSlug}_dealer_transactions.xlsx`);
  };


  // ── Fetch all tables (no timeframe) ─────────────────────
  const fetchAllTables = async () => {
    setError("");
    try {
      const url = `/${tenantSlug}/api/tables/data?${buildSortParam()}`;
      const { data } = await axios.get(url);
      setShowTables(true);
      setTablesData(data);
    } catch (err) {
      console.error("Fetch all tables failed", err);
      setError(err.response?.data?.error || "Failed to fetch");
    }
  };

  // ── Fetch tables within the chosen date range ───────────
  const fetchTablesInRange = async () => {
    setError("");
    if (!start || !end) {
      setError("Both start and end dates must be set");
      return;
    }
    try {
      // Append 1 AM / 11 PM time to each “YYYY-MM-DD”
      const startParam = `${start} 00:00:01`;
      const endParam   = `${end} 23:59:59`;

      // NOTE: We include both start/end & sort_by in the query string:
    const url =
      `/${tenantSlug}/api/tables/data?start=${encodeURIComponent(startParam)}&end=${encodeURIComponent(endParam)}` +
      buildSortParam();



      const { data } = await axios.get(url);
      setTablesData(data);
      setShowTables(true);
    } catch (err) {
      console.error("Fetch tables with range failed", err);
      setError(err.response?.data?.error || "Failed to fetch");
    }
  };

  const exportToExcel = () => {
    if (!tablesData || tablesData.length === 0) {
      alert("No data to export.");
      return;
    }

    // 1) Convert our array of objects into a SheetJS worksheet
    const worksheet = XLSX.utils.json_to_sheet(tablesData);

    // 2) Create a new workbook and append that worksheet under a name (e.g. "Tables")
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Tables");

    // 3) Trigger the file download. The filename can be anything you like.
    XLSX.writeFile(workbook, `${tenantSlug}_tables.xlsx`);
  };

  const createStaffUser = async (e) => {
    e.preventDefault();
    setStaffError("");
    setStaffSuccess("");

    // Basic front‐end validation
    if (!staffEmail.trim() || !staffPassword) {
      setStaffError("Both email and password are required.");
      return;
    }

    if (staffPassword !== staffPasswordRepeat) { // ← added
      setStaffError("Passwords do not match."); // ← added
      return; // ← added
    }

    try {
      const payload = {
        email: staffEmail.trim().toLowerCase(),
        password: staffPassword,
        role: staffRole,
      };
      const { data: newUser } = await axios.post(
        `/${tenantSlug}/api/users`,
        payload
      );
      // If we get here, user was created successfully
      setStaffSuccess(`Created staff: ${newUser.email}`);
      setStaffEmail("");
      setStaffPassword("");
      setStaffPasswordRepeat("");
    } catch (err) {
      console.error("Error creating staff user:", err);
      // Show either the server‐sent error or a generic fallback
      setStaffError(err.response?.data?.error || "Unable to create user");
    }
  };



  const fetchPlayerTransactions = async () => {
    setPlayerError("");
    setShowPlayerTxns(false);

    if (!selectedPlayer) {
      setPlayerError("Please select a player.");
      return;
    }

    const playerId = selectedPlayer.value;
    let url = `/${tenantSlug}/api/players/${playerId}/backtransactions`;

    // If both playerStart and playerEnd are provided, append them
    if (playerStart && playerEnd) {
      const startParam = `${playerStart} 00:00:01`;
      const endParam   = `${playerEnd} 23:59:59`;
      url += `?start=${encodeURIComponent(startParam)}&end=${encodeURIComponent(endParam)}`;
    }

    try {
      const { data } = await axios.get(url);
      setPlayerTxns(data);
      setShowPlayerTxns(true);
    } catch (err) {
      console.error("Fetch player transactions failed:", err);
      setPlayerError(err.response?.data?.error || "Failed to fetch transactions");
    }
  };


    const fetchDealerTransactions = async () => {
        setDealerError("");
        setShowDealerTxns(false);

        if (!selectedDealer) {
            setDealerError("Please select a dealer.");
            return;
        }

        const dealerId = selectedDealer.value;
        let url = `/${tenantSlug}/api/dealers/${dealerId}/backtransactions`;

        if (dealerStart && dealerEnd) {
            const startParam = `${dealerStart} 00:00:01`;
            const endParam   = `${dealerEnd} 23:59:59`;
            url += `?start=${encodeURIComponent(startParam)}&end=${encodeURIComponent(endParam)}`;
        }

        try {
            const { data } = await axios.get(url);
            setDealerTxns(data);
            setShowDealerTxns(true);
        } catch (err) {
            console.error("Fetch dealer transactions failed:", err);
            setDealerError(err.response?.data?.error || "Failed to fetch transactions");
        }
    };



  const fetchAllPlayers = async () => {
    setPlayersError("");
    try {
      // Build URL with ?sort_by=<playerSortBy>
    const url = `/${tenantSlug}/api/players/data?sort_by=${encodeURIComponent(
      playerSortBy
    )}&order=${encodeURIComponent(sortPlayerOrder)}`;
      const { data } = await axios.get(url);
      setPlayersData(data);
      setShowPlayersData(true);
    } catch (err) {
      console.error("Fetch all players failed:", err);
      setPlayersError(
        err.response?.data?.error || "Unable to fetch players data"
      );
    }
  };

  // ── Download “All Players” to Excel ─────────────────────────
  const exportPlayersToExcel = () => {
    if (!playersData || playersData.length === 0) {
      alert("No players data to export.");
      return;
    }
    // Convert `playersData` (array of objects) to SheetJS worksheet
    const worksheet = XLSX.utils.json_to_sheet(playersData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Players");
    XLSX.writeFile(workbook, `${tenantSlug}_players_data.xlsx`);
  };





  // ── Fetch “All Dealers” with optional sort ──────────────────
 const fetchAllDealers = async () => {
   setDealersError("");
   try {
     const url = `/${tenantSlug}/api/dealers/data?sort_by=${encodeURIComponent(
       dealerSortBy
     )}`;
     const { data } = await axios.get(url);
     setDealersData(data);
     setShowDealersData(true);
   } catch (err) {
     console.error("Fetch all dealers failed:", err);
     setDealersError(
       err.response?.data?.error || "Unable to fetch dealers data"
     );
   }
 };

  // ── Download “All Dealers” to Excel ────────────────────────
 const exportDealersToExcel = () => {
   if (!dealersData || dealersData.length === 0) {
     alert("No dealers data to export.");
     return;
   }
   const worksheet = XLSX.utils.json_to_sheet(dealersData);
   const workbook = XLSX.utils.book_new();
   XLSX.utils.book_append_sheet(workbook, worksheet, "Dealers");
   XLSX.writeFile(workbook, `${tenantSlug}_dealers_data.xlsx`);
 };



const fetchBackendData = async () => {
  setBackendError("");
  setShowBackendData(false);
  if (
    !includePlayers &&
    !includeDealers &&
    !includeBonuses &&
    !includeCosts &&
    !includeRake &&
    !includeDebt
  ) {
    setBackendError("Select at least one data type (players, dealers, etc.).");
    return;
  }
  if (!backendStart || !backendEnd) {
    setBackendError("Both start and end dates must be set.");
    return;
  }
  try {
    const params = new URLSearchParams();
    params.append("start", `${backendStart} 00:00:01`);
    params.append("end", `${backendEnd} 23:59:59`);
    if (includePlayers) params.append("players", "1");
    if (includeDealers) params.append("dealers", "1");
    if (includeBonuses) params.append("bonuses", "1");
    if (includeCosts) params.append("costs", "1");
    if (includeRake) params.append("rake", "1");
    if (includeDebt) params.append("debt", "1");
    const url = `/${tenantSlug}/api/backend-data?${params.toString()}`;
    const { data } = await axios.get(url);
    setBackendData(data);
    setShowBackendData(true);
  } catch (err) {
    console.error("Fetch backend data failed:", err);
    setBackendError(err.response?.data?.error || "Failed to load backend data.");
  }
};

const exportBackendToExcel = () => {
  if (!backendData || backendData.length === 0) {
    alert("No backend data to export.");
    return;
  }
  const worksheet = XLSX.utils.json_to_sheet(backendData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "BackendData");
  XLSX.writeFile(workbook, `${tenantSlug}_backend_data.xlsx`);
};





  return ( 
    <div style={{ padding: "2rem" }}>

      <div className="top-buttons">
        <button onClick={() => navigate(`/${tenantSlug}/wallets`)}> Wallets</button> 
        <button onClick={() => navigate(`/${tenantSlug}/players`)}> Players & Dealers</button> 
        <button onClick={() => navigate(`/${tenantSlug}/misc`)}> Misc </button>          
        
      </div>
      <div className="top-right">
        <button onClick={() => navigate(`/${tenantSlug}/game`)}> Game Operations </button>
        <button
          onClick={() => {
            localStorage.removeItem("token");
            navigate(`/${tenantSlug}/login`);
          }}
        >
          Log out
        </button>
      </div>
        
      <h2>{tenantSlug} – Backend</h2>


        {/* ── Create Staff User Form ───────────────────────────────── */}
        <section style={{ marginBottom: "2rem" }}>
        <h3>Create a Staff User</h3>
            <form
                onSubmit={createStaffUser}
                style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
            }}
            >
            <input
                type="email"
                placeholder="Staff email"
                value={staffEmail}
                onChange={(e) => setStaffEmail(e.target.value)}
                required
                style={{ marginRight: "0.5rem", padding: "0.25rem" }}
            />
            <input
                type="password"
                placeholder="Password"
                value={staffPassword}
                onChange={(e) => setStaffPassword(e.target.value)}
                required
                style={{ marginRight: "0.5rem", padding: "0.25rem" }}
            />
            <input
                type="password"
                placeholder="Repeat Password"               // ← added
                value={staffPasswordRepeat}                 // ← added
                onChange={(e) => setStaffPasswordRepeat(e.target.value)} // ← added
                required                                    // ← added
                style={{ marginRight: "0.5rem", padding: "0.25rem" }} // ← added
            />
            <select
              value={staffRole}
              onChange={(e) => setStaffRole(e.target.value)}
              required
              style={{ marginRight: "0.5rem", padding: "0.25rem" }}
          >
              <option value="">Select Role</option>
              <option value="admin">Admin</option>
              <option value="staff">Staff</option>
              <option value="dealer">Dealer</option>
          </select>

            <button type="submit" style={{ padding: "0.5rem 1rem" }}>
                Create Staff
            </button>
        </form>
        {staffError && (
            <p style={{ color: "red", marginTop: "0.5rem" }}>
            {staffError}
            </p>
        )}
        {staffSuccess && (
            <p style={{ color: "green", marginTop: "0.5rem" }}>
            {staffSuccess}
            </p>
        )}
        </section>


      <section>
      <h3>Tables</h3>
      {/* ── Controls: Date inputs + Sort dropdown + Buttons ────────── */}
      <div style={{ marginBottom: "1rem", display: "flex", flexWrap: "wrap" }}>
        {/* Start date */}
        <label style={{ marginRight: "1rem" }}>
          Start:{" "}
          <input
            type="date"
            value={start}
            onChange={(e) => setStart(e.target.value)}
          />
        </label>

        {/* End date */}
        <label style={{ marginRight: "1rem" }}>
          End:{" "}
          <input
            type="date"
            value={end}
            onChange={(e) => setEnd(e.target.value)}
          />
        </label>

        {/* Sort by dropdown */}
        <label style={{ marginRight: "1rem" }}>
          Sort By:{" "}
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
          >
            <option value="start_time">Start Time</option>
            <option value="total_deposits">Total Deposits</option>
            <option value="total_cashouts">Total Cashouts</option>
            <option value="total_players">Total Players</option>
            <option value="total_tips">Total Tips</option>
            <option value="rake">Rake</option>
            <option value="length">Length</option>
            <option value="avg_deposit">Avg. Deposit</option>
            <option value="end_time">End Time</option>
            <option value="num_deposits"># Deposits</option>
            <option value="num_withdrawals"># Withdrawals</option>
            <option value="avg_withdrawal">Avg. Withdrawal</option>
          </select>
        </label>

        <label style={{ marginRight: "1rem" }}>
          Order:{" "}
          <select
            value={sortOrder}                   // **NEW**
            onChange={(e) => setSortOrder(e.target.value)}  // **NEW**
          >
            <option value="asc">Increasing</option>
            <option value="desc">Decreasing</option>
            </select>
        </label>



        {/* Buttons */}
        <button
          style={{ marginLeft: "0.5rem" }}
          onClick={fetchTablesInRange}
        >
          Fetch in Range
        </button>
        <button
          style={{ marginLeft: "0.5rem" }}
          onClick={fetchAllTables}
        >
          Fetch All
        </button>
        <button
          style={{ marginLeft: "0.5rem" }}
          onClick={exportToExcel}
        >
          Download Excel
        </button>
        <button
            style={{ marginLeft: "0.5rem"}}
            onClick={() => setShowTables(false)}
        >
            Hide Tables
        </button>
      </div>

      {error && <p style={{ color: "red" }}>{error}</p>}

      {/* ── Display table data (same as before) ───────────────────── */}
      {showTables && ( tablesData.length === 0 ? (
        <p>No tables found (or not fetched yet).</p>
      ) : (
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              <th>id</th>
              <th>Created At</th>
              <th>Game Type</th>
              <th>Stakes</th>
              <th>Description</th>
              <th>Bomb Pots?</th>
              <th>Total In</th>
              <th>Total Out</th>
              <th>Total Players</th>
              <th>Total Tips</th>
              <th>Rake</th>
              <th>Length</th>
              <th>Avg. Buy</th>
              <th>Start Time</th>
              <th>End Time</th>
              <th># Deposits</th>
              <th># Withdrawals</th>
              <th>Avg. Withdrawal</th>
            </tr>
          </thead>

          <tbody>
            {tablesData.map((t, idx) => (
              <tr key={idx}>
                <td>
                  <button
                    style={{
                      background: "none",
                      border: "none",
                      color: "blue",
                      textDecoration: "underline",
                      cursor: "pointer",
                      padding: 0,
                      font: "inherit",
                    }}
                    onClick={() => fetchTransactionsForTable(t.id)}
                  >
                    {t.id}
                  </button>
                </td>

                {/* created_at */}
                <td>{new Date(t.created_at).toLocaleString()}</td>

                {/* gameType */}
                <td>{t.gameType}</td>

                {/* stakes */}
                <td>{t.stakes}</td>

                {/* description */}
                <td>{t.description || "—"}</td>

                {/* bombs */}
                <td>{t.bombs ? "Yes" : "No"}</td>

                {/* total_in */}
                <td>{parseFloat(t.total_in || 0).toFixed(0)}</td>

                {/* total_out */}
                <td>{parseFloat(t.total_out || 0).toFixed(0)}</td>

                {/* total_players */}
                <td>{t.total_players}</td>

                {/* total_tips */}
                <td>{parseFloat(t.total_tips || 0).toFixed(0)}</td>

                {/* rake */}
                <td>
                  {typeof t.rake === "number"
                    ? t.rake.toFixed(0)
                    : "—"}
                </td>


                {/* length */}
                <td>{t.length || "—"}</td>

                {/* average_buy */}
                <td>
                  {t.average_buy != null
                    ? parseFloat(t.average_buy).toFixed(0)
                    : "—"}
                </td>

                {/* start_time */}
                <td>
                  {t.start_time
                    ? new Date(t.start_time).toLocaleString(undefined, {
                        year: "numeric",
                        month: "numeric",
                        day: "numeric",
                        hour: "numeric",
                        minute: "2-digit",
                      })
                    : "—"}
                </td>

                {/* end_time */}
                <td>
                  {t.end_time
                    ? new Date(t.end_time).toLocaleTimeString(undefined, {
                        hour: "numeric",
                        minute: "2-digit",
                      })
                    : "—"}
                </td>

                {/* num_deposits */}
                <td>{t.num_deposits ?? 0}</td>

                {/* num_withdrawals */}
                <td>{t.num_withdrawals ?? 0}</td>

                {/* average_withdrawal */}
                <td>
                  {typeof t.average_withdrawal === "number"
                    ? t.average_withdrawal.toFixed(0)
                    : "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ))}


      {showTableTxns && (
        <div style={{ marginTop: "2rem" }}>
          <h4>Transactions for Table {selectedTableId}</h4>
          <button
            onClick={hideTableTransactions}
          >
            Hide
          </button>

          {selectedTableTxns.length === 0 ? (
            <p>No transactions in the last 24 hours for this table.</p>
          ) : (
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th>id</th>
                  <th>Player</th>
                  <th>Type</th>
                  <th>Credit?</th>
                  <th>Amount</th>
                  <th>Completed At</th>
                  <th>Method</th>
                </tr>
              </thead>
              <tbody>
                {selectedTableTxns.map((txn, i) => (
                  <tr key={i}>
                    <td>{txn.id}</td>
                    <td>
                      {players.find(p => p.value === txn.player_id)?.label || txn.player_id}
                    </td>
                    <td>{txn.type}</td>
                    <td>{txn.credit ? "Yes" : "No"}</td>
                    <td>{parseFloat(txn.amount).toFixed(2)}</td>
                    <td>{new Date(txn.completed_at).toLocaleString()}</td>
                    <td>{txn.method || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      </section>


    <section style={{ marginBottom: "2rem" }}>
        <h3>Individual Player Stats</h3>

        {/* ── Controls: Select Player + Date Inputs + Buttons ─────── */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            marginBottom: "1rem",
          }}
        >
          {/* 1) Player select (searchable) */}
          <div style={{ minWidth: "200px", marginRight: "1rem" }}>
            <Select
              options={players}
              value={selectedPlayer}
              onChange={(val) => setSelectedPlayer(val)}
              placeholder="Select player..."
              isClearable
            />
          </div>

          {/* 2) Start date for player */}
          <label style={{ marginRight: "1rem" }}>
            Start:{" "}
            <input
              type="date"
              value={playerStart}
              onChange={(e) => setPlayerStart(e.target.value)}
            />
          </label>

          {/* 3) End date for player */}
          <label style={{ marginRight: "1rem" }}>
            End:{" "}
            <input
              type="date"
              value={playerEnd}
              onChange={(e) => setPlayerEnd(e.target.value)}
            />
          </label>

          {/* 4) Go (fetch with timeframe) */}
          <button
            style={{ marginRight: "0.5rem" }}
            onClick={fetchPlayerTransactions}
          >
            Go
          </button>

          {/* 5) Fetch All (ignores dates) */}
          <button
            style={{ marginRight: "0.5rem" }}
            onClick={() => {
              // Temporarily clear date filters and fetch
              const prevStart = playerStart;
              const prevEnd = playerEnd;
              setPlayerStart("");
              setPlayerEnd("");
              fetchPlayerTransactions(); // will fetch without ?start&end
              // Restore date inputs (if you want to keep them visible)
              setPlayerStart(prevStart);
              setPlayerEnd(prevEnd);
            }}
          >
            Fetch All
          </button>

          {/* 6) Download Excel (exports playerTxns) */}
          <button
            style={{ marginRight: "0.5rem" }}
            onClick={exportPlayerToExcel}
          >
            Download Excel
          </button>

          {/* 7) Hide (clears the table) */}
          <button onClick={() => setShowPlayerTxns(false)}>Hide</button>
        </div>

        {playerError && <p style={{ color: "red" }}>{playerError}</p>}

        {/* ── If showPlayerTxns is true, render a <table> ─────────── */}
        {showPlayerTxns && (
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "1rem",
            }}
          >
            <thead>
              <tr>
                <th>
                  Time
                </th>
                <th>
                  Amount
                </th>
                <th>
                  Type
                </th>
                <th>
                  Credit?
                </th>
                <th>
                  Method
                </th>
                <th>
                  Table ID
                </th>
                <th>
                  Date
                </th>
              </tr>
            </thead>
            <tbody>
              {playerTxns.length === 0 ? (
                <tr>
                  <td
                    colSpan={4}
                    style={{ textAlign: "center", padding: "1rem" }}
                  >
                    No transactions found.
                  </td>
                </tr>
              ) : (
                playerTxns.map((t) => {
                  const amt = parseFloat(t.amount);
                  return (
                    <tr key={t.id}>
                      {/* Time */}
                      <td
                        style={{
                          border: "1px solid #eee",
                          padding: "0.5rem",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {new Date(t.completed_at).toLocaleTimeString(
                          undefined,
                          {
                            hour: "numeric",
                            minute: "2-digit",
                          }
                        )}
                      </td>

                      {/* Amount */}
                      <td>
                        ${amt.toFixed(0)}
                      </td>

                      {/* Type */}
                      <td>
                        {t.type}
                      </td>

                      {/* Credit */}
                      <td>
                        {t.credit ? "Yes" : "No"}
                      </td>

                      <td>
                        {t.method}
                      </td>

                      {/* Table ID */}
                      <td>
                        {t.table_id ?? "—"}
                      </td>

                      {/* Date */}
                      <td>
                        {new Date(t.completed_at).toLocaleDateString(undefined, {
                          month: "numeric",
                          day: "numeric",
                          year: "numeric",
                        })}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        )}
      </section>





{/* ── All Players Section ─────────────────────────────────── */}
      <section style={{ marginBottom: "2rem" }}>
        <h3>All Players</h3>

        {/* ── Controls: Sort dropdown + Buttons ───────────────── */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            marginBottom: "1rem",
          }}
        >
          {/* 1) Sort By dropdown */}
          <label style={{ marginRight: "1rem" }}>
            Sort By:{" "}
            <select
              value={playerSortBy}
              onChange={(e) => setPlayerSortBy(e.target.value)}
            >
              <option value="created_at">Created At</option>
              <option value="total_sent_out">Total Sent Out</option>
              <option value="total_paid_out">Total Paid Out</option>
              <option value="profit">Profit</option>
              <option value="owed">Owed</option>
              <option value="last_played">Last Played</option>
              <option value="total_playing_time">Playing Time</option>
              <option value="total_bonuses">Bonuses</option>
              <option value="num_bonuses"># Bonuses</option>
            </select>
          </label>

          <label style={{ marginRight: "1rem" }}>
            Order:{" "}
            <select
              value={sortPlayerOrder}                   // **NEW**
              onChange={(e) => setSortPlayerOrder(e.target.value)}  // **NEW**
            >
              <option value="asc">Increasing</option>
              <option value="desc">Decreasing</option>
            </select>
          </label>


          {/* 2) Go (fetch with sort) */}
          <button
            style={{ marginRight: "0.5rem" }}
            onClick={fetchAllPlayers}
          >
            Go
          </button>

          {/* 3) Download Excel */}
          <button
            style={{ marginRight: "0.5rem" }}
            onClick={exportPlayersToExcel}
          >
            Download Excel
          </button>

          {/* 4) Hide */}
          <button onClick={() => setShowPlayersData(false)}>
            Hide
          </button>
        </div>

        {/* 5) Any fetch‐error message */}
        {playersError && (
          <p style={{ color: "red", marginBottom: "0.5rem" }}>
            {playersError}
          </p>
        )}

        {/* 6) If showPlayersData is true, render the table */}
        {showPlayersData && (
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "1rem",
            }}
          >
            <thead>
              <tr>
                <th>
                  ID
                </th>
                <th>
                  Name
                </th>
                <th>
                  Created At
                </th>
                <th>
                  Phone Number
                </th>
                <th>
                  Total Sent Out
                </th>
                <th>
                  Total Paid Out
                </th>
                <th>
                  Profit
                </th>
                <th>
                  Owed
                </th>
                <th>
                  Last Played
                </th>
                <th>
                  Playing Time
                </th>
                <th>
                  Bonuses
                </th>
                <th>
                  Num of Bonuses
                </th>
              </tr>
            </thead>
            <tbody>
              {playersData.length === 0 ? (
                <tr>
                  <td
                    colSpan={9}
                  >
                    No players found.
                  </td>
                </tr>
              ) : (
                playersData.map((p) => {
                  // Format numeric columns and dates
                  const formattedCreated = new Date(
                    p.created_at
                  ).toLocaleString();
                  const formattedSentOut = parseFloat(
                    p.total_sent_out || 0
                  ).toFixed(0);
                  const formattedPaidOut = parseFloat(
                    p.total_paid_out || 0
                  ).toFixed(0);
                  const formattedProfit = parseFloat(
                    p.profit || 0
                  ).toFixed(0);
                  const formattedOwed = parseFloat(p.owed || 0).toFixed(0);
                  const formattedCurrStart = p.last_played
                    ? new Date(p.last_played).toLocaleString()
                    : "—";
                  const formattedPlayingTime =
                    p.total_playing_time || "—";

                  return (
                    <tr key={p.id}>
                      <td>
                        {p.id}
                      </td>
                      <td>
                        {p.name}
                      </td>
                      <td>
                        {formattedCreated}
                      </td>
                      <td>
                        {p.phone_number ? `${p.phone_number.slice(0, 3)}-${p.phone_number.slice(3, 6)}-${p.phone_number.slice(6)}` : ""}
                      </td>
                      <td>
                        {formattedSentOut}
                      </td>
                      <td>
                        {formattedPaidOut}
                      </td>
                      <td>
                        {formattedProfit}
                      </td>
                      <td>
                        {formattedOwed}
                      </td>
                      <td>
                        {formattedCurrStart}
                      </td>
                      <td>
                        {formattedPlayingTime}
                      </td>
                      <td>
                        {p.total_bonuses}
                      </td>
                      <td>
                        {p.num_bonuses}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        )}
      </section>






    <section style={{ marginBottom: "2rem" }}>
        <h3>Individual Dealer Stats</h3>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            marginBottom: "1rem",
          }}
        >
          <div style={{ minWidth: "200px", marginRight: "1rem" }}>
            <Select
              options={dealers}
              value={selectedDealer}
              onChange={(val) => setSelectedDealer(val)}
              placeholder="Select dealer..."
              isClearable
            />
          </div>

          <label style={{ marginRight: "1rem" }}>
            Start:{" "}
            <input
              type="date"
              value={dealerStart}
              onChange={(e) => setDealerStart(e.target.value)}
            />
          </label>

          <label style={{ marginRight: "1rem" }}>
            End:{" "}
            <input
              type="date"
              value={dealerEnd}
              onChange={(e) => setDealerEnd(e.target.value)}
            />
          </label>

          <button
            style={{ marginRight: "0.5rem" }}
            onClick={fetchDealerTransactions}
          >
            Go
          </button>

          <button
            style={{ marginRight: "0.5rem" }}
            onClick={() => {
              // Temporarily clear date filters and fetch
              const prevStart = dealerStart;
              const prevEnd = dealerEnd;
              setDealerStart("");
              setDealerEnd("");
              fetchDealerTransactions(); // will fetch without ?start&end
              setDealerStart(prevStart);
              setDealerEnd(prevEnd);
            }}
          >
            Fetch All
          </button>

          {/* 6) Download Excel (exports playerTxns) */}
          <button
            style={{ marginRight: "0.5rem" }}
            onClick={exportDealerToExcel}
          >
            Download Excel
          </button>

          {/* 7) Hide (clears the table) */}
          <button onClick={() => setShowDealerTxns(false)}>Hide</button>
        </div>

        {dealerError && <p style={{ color: "red" }}>{dealerError}</p>}

        {/* ── If showPlayerTxns is true, render a <table> ─────────── */}
        {showDealerTxns && (
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              marginTop: "1rem",
            }}
          >
            <thead>
              <tr>
                <th>
                  Time
                </th>
                <th>
                  Amount
                </th>
                <th>
                  Table ID
                </th>
                <th>
                  Date
                </th>
              </tr>
            </thead>
            <tbody>
              {dealerTxns.length === 0 ? (
                <tr>
                  <td
                    colSpan={6}
                    style={{ textAlign: "center", padding: "1rem" }}
                  >
                    No transactions found.
                  </td>
                </tr>
              ) : (
                dealerTxns.map((t) => {
                  const amt = parseFloat(t.amount);
                  return (
                    <tr key={t.id}>
                      {/* Time */}
                      <td
                        style={{
                          border: "1px solid #eee",
                          padding: "0.5rem",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {new Date(t.completed_at).toLocaleTimeString(
                          undefined,
                          {
                            hour: "numeric",
                            minute: "2-digit",
                          }
                        )}
                      </td>

                      {/* Amount */}
                      <td>
                        ${amt.toFixed(0)}
                      </td>

                      {/* Table ID */}
                      <td>
                        {t.table_id ?? "—"}
                      </td>

                      {/* Date */}
                      <td>
                        {new Date(t.completed_at).toLocaleDateString(undefined, {
                          month: "numeric",
                          day: "numeric",
                          year: "numeric",
                        })}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        )}
      </section>








{/* ── All Dealers Section ─────────────────────────────────── */}
<section style={{ marginBottom: "2rem" }}>
  <h3>All Dealers</h3>

  {/* ── Controls: Sort dropdown + Buttons ───────────────── */}
  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      marginBottom: "1rem",
    }}
  >
    {/* 1) Sort By dropdown */}
    <label style={{ marginRight: "1rem" }}>
      Sort By:{" "}
      <select
        value={dealerSortBy}
        onChange={(e) => setDealerSortBy(e.target.value)}
      >
        <option value="tips">Tips</option>
        <option value="last_dealt">Last Dealt</option>
      </select>
    </label>

    {/* 2) Go (fetch with sort) */}
    <button
      style={{ marginRight: "0.5rem" }}
      onClick={fetchAllDealers}
    >
      Go
    </button>

    {/* 3) Download Excel */}
    <button
      style={{ marginRight: "0.5rem" }}
      onClick={exportDealersToExcel}
    >
      Download Excel
    </button>

    {/* 4) Hide */}
    <button onClick={() => setShowDealersData(false)}>Hide</button>
  </div>

  {/* 5) Any fetch‐error message */}
  {dealersError && (
    <p style={{ color: "red", marginBottom: "0.5rem" }}>
      {dealersError}
    </p>
  )}

  {/* 6) If showDealersData is true, render the table */}
  {showDealersData && (
    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        marginTop: "1rem",
      }}
    >
      <thead>
        <tr>
          <th>
            ID
          </th>
          <th>
            Name
          </th>
          <th>
            Tips
          </th>
          <th>
            Last Dealt
          </th>
        </tr>
      </thead>
      <tbody>
        {dealersData.length === 0 ? (
          <tr>
            <td colSpan={4} style={{ textAlign: "center", padding: "1rem" }}>
              No dealers found.
            </td>
          </tr>
        ) : (
          dealersData.map((d) => {
            const formattedTips = parseFloat(d.tips || 0).toFixed(0);
            const formattedLast = d.last_dealt
              ? new Date(d.last_dealt).toLocaleString()
              : "—";

            return (
              <tr key={d.id}>
                <td>
                  {d.id}
                </td>
                <td>
                  {d.name}
                </td>
                <td>
                  {formattedTips}
                </td>
                <td>
                  {formattedLast}
                </td>
              </tr>
            );
          })
        )}
      </tbody>
    </table>
  )}
</section>
{/* ── End All Dealers Section ────────────────────────────── */}







<section style={{ marginBottom: "2rem" }}>
  <h3>Backend Data</h3>

  {/* Controls: Date inputs + Checkboxes + Buttons */}
  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      marginBottom: "1rem",
      gap: "1rem",
    }}
  >
    <label>
      Start:{" "}
      <input
        type="date"
        value={backendStart}
        onChange={(e) => setBackendStart(e.target.value)}
      />
    </label>

    <label>
      End:{" "}
      <input
        type="date"
        value={backendEnd}
        onChange={(e) => setBackendEnd(e.target.value)}
      />
    </label>

    <label style={{ display: "flex", alignItems: "center" }}>
      <input
        type="checkbox"
        checked={includePlayers}
        onChange={(e) => setIncludePlayers(e.target.checked)}
      />
      <span style={{ marginLeft: "0.25rem" }}>Players</span>
    </label>

    <label style={{ display: "flex", alignItems: "center" }}>
      <input
        type="checkbox"
        checked={includeDealers}
        onChange={(e) => setIncludeDealers(e.target.checked)}
      />
      <span style={{ marginLeft: "0.25rem" }}>Dealers</span>
    </label>

    <label style={{ display: "flex", alignItems: "center" }}>
      <input
        type="checkbox"
        checked={includeBonuses}
        onChange={(e) => setIncludeBonuses(e.target.checked)}
      />
      <span style={{ marginLeft: "0.25rem" }}>Bonuses</span>
    </label>

    <label style={{ display: "flex", alignItems: "center" }}>
      <input
        type="checkbox"
        checked={includeCosts}
        onChange={(e) => setIncludeCosts(e.target.checked)}
      />
      <span style={{ marginLeft: "0.25rem" }}>Costs</span>
    </label>

    <label style={{ display: "flex", alignItems: "center" }}>
      <input
        type="checkbox"
        checked={includeRake}
        onChange={(e) => setIncludeRake(e.target.checked)}
      />
      <span style={{ marginLeft: "0.25rem" }}>Rake</span>
    </label>
    
    <label style={{ display: "flex", alignItems: "center" }}>
      <input
        type="checkbox"
        checked={includeDebt}
        onChange={(e) => setIncludeDebt(e.target.checked)}
      />
      <span style={{ marginLeft: "0.25rem" }}>Debt</span>
    </label>

    <button onClick={fetchBackendData}>Go</button>
    <button onClick={exportBackendToExcel}>Download Excel</button>
    <button onClick={() => setShowBackendData(false)}>Hide</button>
  </div>

  {backendError && (
    <p style={{ color: "red", marginBottom: "0.5rem" }}>
      {backendError}
    </p>
  )}

  {showBackendData && (
    <table
      style={{
        width: "100%",
        borderCollapse: "collapse",
        marginTop: "1rem",
      }}
    >
      <thead>
        <tr>
          <th>Time</th>
          <th>Date</th>
          <th>Player/Dealer</th>
          <th>Amount</th>
          <th>Type</th>
          <th>Method</th>
          <th>Credit?</th>
          <th>Table ID</th>
        </tr>
      </thead>
      <tbody>
        {backendData.length === 0 ? (
          <tr>
            <td
              colSpan={8}
              style={{ textAlign: "center", padding: "1rem" }}
            >
              No records found.
            </td>
          </tr>
        ) : (
          backendData.map((row, idx) => (
            <tr key={idx}>
              <td style={{ whiteSpace: "nowrap", padding: "0.5rem" }}>
                {new Date(row.completed_at || row.timestamp).toLocaleTimeString(
                  undefined,
                  { hour: "numeric", minute: "2-digit" }
                )}
              </td>
              <td>
                {new Date(row.completed_at || row.timestamp).toLocaleDateString(
                  undefined,
                  { month: "numeric", day: "numeric", year: "numeric" }
                )}
              </td>
              <td>{row.player_or_dealer || "—"}</td>
              <td>
                {typeof row.amount === "number"
                  ? `$${row.amount.toFixed(2)}`
                  : row.amount}
              </td>
              <td>{row.type || "—"}</td>
              <td>{row.method || "—"}</td>
              <td>{row.credit ? "Yes" : "No"}</td>
              <td>{row.table_id ?? "—"}</td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  )}
</section>





{/* ── NEW: Display total stats at the top ─────────────────────── */}
      <section style={{ marginBottom: "2rem" }}>
        <h3>Total Stats</h3>
        {statsLoading ? (
          <p>Loading stats…</p>
        ) : statsError ? (
          <p style={{ color: "red" }}>{statsError}</p>
        ) : (
          <div style={{ display: "flex", gap: "1.5rem" }}>
            <div>
              <strong>Tables’ Rake:</strong>{" "}
              ${stats.total_table_rake.toFixed(0)}
            </div>
            <div>
              <strong>Total Costs:</strong> ${stats.total_costs.toFixed(0)}
            </div>
                        <div>
              <strong>Total Bonuses:</strong> ${stats.total_bonuses}
            </div>
            <div>
              <strong>Net Profit:</strong>{" "}
              <span>
                ${stats.net_profit.toFixed(0)}
              </span>
            </div>
          </div>
        )}
      </section>



    </div>
  );
}
